import { render, staticRenderFns } from "./cookie-law.vue?vue&type=template&id=1abd8559"
import script from "./cookie-law.vue?vue&type=script&lang=js"
export * from "./cookie-law.vue?vue&type=script&lang=js"
import style0 from "./cookie-law.vue?vue&type=style&index=0&id=1abd8559&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports